module.exports = __webpack_public_path__ + "img/performance-work-icon2.e0922b22.png";